import { Navigate, useLocation } from "react-router-dom"
import { useAuth } from "@/context/AuthContext"

export default function RequireAuth({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isBootstrapping } = useAuth()
  const location = useLocation()

  if (isBootstrapping) {
    return (
      <div className="flex min-h-dvh flex-col items-center justify-center gap-3 bg-guardians-bg">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-guardians-accent border-t-transparent" />
        <p className="text-sm text-guardians-muted">Хранители</p>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  return children
}
